import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    getOrderStatus,
    OrderStatusParams,
    OrderStatusResultModel,
} from "@tSurya/Services/OrderStatusInfo/OrderStatusService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<OrderStatusParams & HasOnSuccess & HasOnError, OrderStatusResultModel | string>;

export const DispatchLoadingOrderStatus: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderStatus/BeginLoadOrderStatus",
        params: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getOrderStatus(props.apiParameter);
    } catch (error) {
        if (isApiError(error)) {
            props.parameter.onError?.(error.errorJson.message);
            props.dispatch({
                type: "Data/OrderStatus/CompleteLoadOrderStatus",
                result: props.apiResult,
            });
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult as any);
};

export const DispatchCompleteLoadingOrderStatus: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Data/OrderStatus/CompleteLoadOrderStatus",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchLoadingOrderStatus,
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    DispatchCompleteLoadingOrderStatus,
];

const getOrderStatusDetails = createHandlerChainRunner(chain, "getOrderStatusDetails");

export default getOrderStatusDetails;
